import { BaseObject } from "@adgate/common/types/base-object.type";
import { Status } from "@adgate/common/types/status.type";

export class ProductionRequest extends BaseObject
{
    public static OBJECT_TYPE:number = 4;

    requestId!: number;
    client!: string;
    name!: string;
    requireVoiceover!: boolean;
    voiceoverDetails!: string;
    requireSample!: boolean;
    airDate!: number;
    origin!: string;
    notes!: string;
    status: Status;
    dateCreated!: number | null;
    masterCommercialId!: number | null;
    masterCommercialRefCode!: string | null;
    masterCommercialBrand!: string | null;
    masterCommercialProduct!: string | null;
    lastModified: number = 0;
    defaultVersionType!: BaseObject;    

    shows: string[] = [];
    // samples!: ProductionOrderSample[];

    constructor()
    {
        super();
        this.status = { id: Status.PRODUCTION_REQUEST_CREATED, description: 'Created' };
    }
}